<script>
  import BackButton from '../../../components/general/BackButton.vue'

  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'

  import bus from '@utils/bus'

  export default {
    components: {BackButton},
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        list: [],
        event: {
          id: '',
          title: ''
        },
        registrations: [],
        registrationsPresence: []
      }
    },
    mounted () {
      bus.$emit('show-loader')
      this.event.id = this.$route.params.id
      this.getEvent(this.event.id)
    },
    methods: {
      getEvent (id) {
        restfulService.get('event', 'participants', id)
          .then((response) => {
            this.event = {...response.event}
            this.registrations = [...response.registrations]
            if (this.registrations.length > 0) {
              setTimeout(() => {
                this.registrations.forEach(item => {
                  if (item.presence) {
                    this.$refs.presenceTable.toggleRowSelection(item)
                  }
                })
              }, 300)
            }
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isLoadingData = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      selectionChange (val) {
        this.registrationsPresence = [...val]
      },
      onSavePresence () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {registrations: this.registrationsPresence}
        restfulService.post('event', 'participant/presence', this.event.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.getEvent(this.event.id)
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="custom-list">
        <h2>Presenças</h2>
        <h4 class="header-subtitle">Minicurso: {{event.title}}</h4>
        <div class="flex-header">
            <h4>Total Inscritos: {{registrations.length}}</h4>
            <el-button type="primary" @click="onSavePresence">
                <i class="fa fa-check"></i>
                <span>Gravar Presença</span>
            </el-button>
        </div>
        <el-table :data="registrations"
                  ref="presenceTable"
                  @selection-change="selectionChange"
                  style="margin-top: 15px;">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column label="Cód. Inscrição" width="120">
                <template slot-scope="scope">{{ scope.row.registration_id }}</template>
            </el-table-column>
            <el-table-column label="Pessoa">
                <template slot-scope="scope">{{ scope.row.person }} ({{ scope.row.ref_pessoa }})</template>
            </el-table-column>
        </el-table>
    </div>
</template>
